var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2512 0.0680755C11.3491 0.124814 11.4248 0.213066 11.466 0.318413C11.5073 0.423761 11.5116 0.539977 11.4782 0.648076L9.6772 6.50008H13.0002C13.0979 6.50004 13.1934 6.52859 13.275 6.58223C13.3566 6.63586 13.4207 6.71221 13.4594 6.80187C13.4981 6.89152 13.5098 6.99055 13.4928 7.08673C13.4759 7.18291 13.4312 7.27202 13.3642 7.34308L5.3642 15.8431C5.28679 15.9254 5.18379 15.9791 5.07197 15.9953C4.96016 16.0116 4.84613 15.9895 4.74847 15.9327C4.65081 15.8759 4.57528 15.7876 4.53419 15.6824C4.4931 15.5771 4.48887 15.461 4.5222 15.3531L6.3232 9.50008H3.0002C2.90254 9.50011 2.80702 9.47155 2.72541 9.41792C2.6438 9.36429 2.57968 9.28794 2.54096 9.19828C2.50225 9.10863 2.49064 9.0096 2.50757 8.91342C2.52449 8.81725 2.56921 8.72813 2.6362 8.65707L10.6362 0.157076C10.7135 0.0748746 10.8164 0.0212441 10.928 0.00490408C11.0397 -0.011436 11.1536 0.0104754 11.2512 0.0670755V0.0680755ZM4.1572 8.50008H7.0002C7.07845 8.50006 7.15561 8.51841 7.22547 8.55365C7.29533 8.58889 7.35595 8.64003 7.40245 8.70297C7.44895 8.7659 7.48002 8.83887 7.49318 8.91601C7.50633 8.99314 7.5012 9.07229 7.4782 9.14708L6.1102 13.5901L11.8422 7.50008H9.0002C8.92195 7.50009 8.84479 7.48174 8.77493 7.4465C8.70506 7.41126 8.64445 7.36012 8.59795 7.29718C8.55145 7.23425 8.52038 7.16128 8.50722 7.08414C8.49406 7.00701 8.49919 6.92787 8.5222 6.85308L9.8902 2.41008L4.1572 8.50008Z",
    fill: "#0688FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectric);
export default __webpack_public_path__ + "static/media/icon-electric.113e007e295d77979999b822152f442c.svg";
export { ForwardRef as ReactComponent };